export const ContactDetailsWizardMutations = {}
